<template>
  <div>
    <brb-input
      v-model="model"
      :label="label"
      :id="id"
      v-bind="$attrs"
      dir="ltr"
    />

    <date-picker
      v-model="model"
      :class="{ hour: type === 'hour' }"
      :type="computedType"
      :element="id"
      :min="computedMin"
      :max="computedMax"
      :auto-submit="autoSubmit"
      :color="color"
      :simple="simple"
      use-router
      @input="$emit('input', createModelOut($event))"
    />
  </div>
</template>

<script>
import DatePicker from 'vue-persian-datetime-picker'
import jMoment from 'moment-jalaali'

export default {
  name: 'BrbDateTimePicker',
  components: {
    DatePicker
  },
  props: {
    value: {
      default: null
    },
    // brb-input props
    label: String,
    id: {
      type: String,
      default: () => `brb-date-time-picker-${parseInt(Math.random() * 1000)}`
    },
    // component props
    type: {
      type: String,
      default: 'date'
    },
    min: String,
    max: String,
    autoSubmit: Boolean,
    color: String,
    simple: Boolean,
    endOfDay: Boolean
  },
  computed: {
    model: {
      get() {
        return this.createModelIn(this.value)
      },
      set(value) {
        this.$emit('input', this.createModelOut(value))
      }
    },
    computedType() {
      switch (this.type) {
        case 'hour':
          return 'time'
        case 'date-time':
          return 'datetime'
        case 'date-time-automatic':
          return 'date'
        default:
          return this.type
      }
    },
    computedMin() {
      return this.min && this.type !== 'time' && this.type !== 'hour'
        ? jMoment(this.min, 'YYYY/MM/DD HH:mm:ssZ').format('jYYYY/jM/jD')
        : this.min
    },
    computedMax() {
      return this.max && this.type !== 'time' && this.type !== 'hour'
        ? jMoment(this.max, 'YYYY/MM/DD HH:mm:ssZ').format('jYYYY/jM/jD')
        : this.max
    }
  },
  methods: {
    createModelIn(value) {
      if (!value) return value

      if (this.type === 'time') return value

      if (['date', 'date-time-automatic'].includes(this.type)) {
        return jMoment(value, 'YYYY/MM/DD HH:mm:ssZ').format('jYYYY/jM/jD dddd')
      }

      if (this.type === 'date-time') {
        return jMoment(value, 'YYYY/MM/DD HH:mm').format(
          'jYYYY/jM/jD HH:mm day'
        )
      }

      if (this.type === 'hour') {
        return jMoment(value, 'HH:mm').format('HH')
      }
    },
    createModelOut(value) {
      if (!value) return value

      if (this.type === 'time') return value

      if (this.type === 'date') {
        return jMoment(value, 'jYYYY/jM/jD').format('YYYY/MM/DD dddd')
      }

      if (this.type === 'date-time') {
        const dateTime = jMoment(value, 'jYYYY/jM/jD HH:mm').format(
          'YYYY/MM/DD HH:mm'
        )
        return jMoment(dateTime).utc().format()
      }

      if (this.type === 'hour') {
        return jMoment(value, 'HH:mm').format('HH')
      }

      if (this.type === 'date-time-automatic') {
        const time = `${this.endOfDay ? 23 : '00'}:${
          this.endOfDay ? 59 : '00'
        }:${this.endOfDay ? 59 : '00'}`

        const dateTime = jMoment(
          `${value} ${time}`,
          'jYYYY/jM/jD HH:mm'
        ).format('YYYY/MM/DD HH:mm')
        return jMoment(dateTime).utc().format()
      }

      return value
    }
  }
}
</script>

<style>
.hour .vpd-time-column:nth-child(1) {
  width: 100%;
}
.hour .vpd-time-column:nth-child(1)::after {
  content: none;
}
.hour .vpd-time-column:nth-child(2) {
  display: none;
}
</style>
